export default __webpack_public_path__ + "static/media/category2.ffdaa396.png";